import React, { memo, useState } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';

interface Props {
  requestModule(): Promise<any>;
  validationRequest(): Promise<any>;
  reception_id: number;
  reception_cd: string;
  status_code: number;
}

// KWANKGM11020_事前審査結果入力（承認・不承認）（職員）フッタボタン
const FooterPreExaminationResultInputStaff: React.FC<Props> = ({
  requestModule,
  validationRequest,
  reception_id,
  reception_cd,
  status_code,
}) => {
  const [confirm_open, setConfirmOpen] = useState(false);
  const [info_open, setInfoOpen] = useState(false);
  const [error_open, setErrorOpen] = useState(false);
  const [error_message, setErrorMessage] = useState('');
  const [error_redirct_url, setErrorRedirectUrl] = useState('');

  /**
   * 戻るボタンをクリックする
   * @returns void
   */
  const handleClickReturn = () => {
    location.href = `/reception/${reception_cd}/${reception_id}/${status_code}`;
  };

  /**
   * 完了確認モーダル
   * 完了（承認・不承認）ボタンをクリックする
   * @returns void
   */
  const handleClickComplete = () => {
    setErrorMessage('');
    setErrorRedirectUrl('');
    validationRequest()
      .then(res => {
        setConfirmOpen(true);
      })
      .catch(error => {
        setErrorMessage('message' in error.response.data ? error.response.data.message : '');
        setErrorRedirectUrl('url' in error.response.data ? error.response.data.url : '');
        setErrorOpen(true);
      });
  };

  /**
   * 完了確認モーダル
   * 戻るボタンをクリックする
   * @returns void
   */
  const handleClickModalClose = () => {
    setConfirmOpen(false);
  };

  /**
   * 登録・送信ボタンをクリックする
   * @returns void
   */
  const handleClickModalSend = () => {
    setConfirmOpen(false);

    requestModule()
      .then(res => {
        setInfoOpen(true);
      })
      .catch(error => {
        setErrorMessage('message' in error.response.data ? error.response.data.message : '');
        setErrorRedirectUrl('url' in error.response.data ? error.response.data.url : '');
        setErrorOpen(true);
      });
  };

  /**
   * 結果通知モーダルを閉じる
   * @returns void
   */
  const handleClickModalOk = () => {
    setInfoOpen(false);
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/staff/list`;
  };

  /**
   * エラーポップアップの「OK」押下時
   * @returns void 指定のURLにリダイレクトする
   */
  const handleClickErrorModalOk = () => {
    location.replace(error_redirct_url);
  };

  return (
    <>
      <Row className="my-5">
        <Col xl={6} lg={6} md={6} sm={6} xs={12} className="text-center">
          <a
            className="btn btn-bg-white btn-outline-success btn-text-color px-5"
            onClick={handleClickReturn}
          >
            戻る
          </a>
        </Col>
        <Col xl={6} lg={6} md={6} sm={6} xs={12} className="text-center">
          <a className="btn btn-success" onClick={handleClickComplete}>
            完了(承認・不承認)
          </a>
        </Col>
      </Row>
      {/* 登録・メール送信確認ポップアップ */}
      <Modal
        show={confirm_open}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {}}
      >
        <Modal.Body>上記内容でお客様宛にメールを送信します。よろしいですか？</Modal.Body>
        <Modal.Footer>
          <a
            className="btn btn-bg-white btn-outline-success btn-text-color"
            onClick={handleClickModalClose}
          >
            戻る
          </a>
          <a className="btn btn-success" onClick={handleClickModalSend}>
            登録・送信
          </a>
        </Modal.Footer>
      </Modal>
      {/* メール送信通知ポップアップ */}
      <Modal
        show={info_open}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {}}
      >
        <Modal.Body>お客様に事前審査結果通知メールを送信しました。</Modal.Body>
        <Modal.Footer>
          <a className="btn btn-success" onClick={handleClickModalOk}>
            OK
          </a>
        </Modal.Footer>
      </Modal>
      {/* エラー通知ポップアップ */}
      <Modal
        show={
          error_open &&
          Object.keys(error_message).length !== 0 &&
          Object.keys(error_redirct_url).length !== 0
        }
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {}}
      >
        <Modal.Body>{error_message}</Modal.Body>
        <Modal.Footer>
          <a className="btn btn-success" onClick={handleClickErrorModalOk}>
            OK
          </a>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default memo(FooterPreExaminationResultInputStaff);
